import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

interface IProps {
  hideFirstOption?: boolean;
  status?: string;
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
  onChange?: ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const InvoiceStatusSelect: React.FC<IProps> = memo(
  ({ hideFirstOption = false, status, size, style, onChange }) => {
    return (
      <Select style={{ width: 100, ...style }} defaultValue="All" value={status} size={size} onChange={onChange}>
        {!hideFirstOption && <Option value={undefined}>{L('All')}</Option>}
        <Option value="Unpaid">{L('Unpaid')}</Option>
        <Option value="Paid">{L('Paid')}</Option>
        <Option value="Voided">{L('Voided')}</Option>
      </Select>
    );
  }
);
